module.exports = __webpack_public_path__ + "img/674.e6bdbb74.png";